import useRequestCountryCode from '@alltrails/context/hooks/useRequestCountryCode';
import { useExperiments } from '@alltrails/experiments';

export default function useShowPlusTaxesText() {
  const requestCountryCode = useRequestCountryCode();
  const experiments = useExperiments();

  return experiments['web-taxes']?.value === 'on' && (requestCountryCode === 'US' || requestCountryCode === 'CA');
}
